import { DataUtil } from 'plugin/liferay-widgets-react-web';


export function hasEditPermissionAndGroup(fliwasObject, permission, ignoreGroup = false) {
    const permissionItem = DataUtil.asItem(permission);

    let hasPermission = permissionItem && permissionItem.state && permissionItem.state.toLowerCase() === 'set';

    if(hasPermission && (ignoreGroup || (fliwasObject && fliwasObject.groupId === window.Liferay.ThemeDisplay.getScopeGroupId()))) {
        hasPermission = true;
    } else if(fliwasObject && fliwasObject.groupId != window.Liferay.ThemeDisplay.getScopeGroupId()) {
        hasPermission = false;
    }

    return hasPermission;
}


// WEBPACK FOOTER //
// ./js/utils/editPermissionUtil.js